// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    clientID: 'ASWK2JXrf6tf0v_afZaXRf9upErGr6UHu-UK55M8KpDbbKQoiPkywdO_jkz9aatuD4cN7rRzJzlNuzkJ',
    openSuscriptions: 'https://api.sandbox.paypal.com/v1/billing/subscriptions',
    cancelSuscriptions: 'https://api-m.sandbox.paypal.com/v1/billing/subscriptions',
    CLIENT_ID:'54966495013-ttvj3dvc7to21gm4p7od5hdui2tetouo.apps.googleusercontent.com',
    CLIENT_SECRET:'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',
    REDIRECT_URL: 'http://localhost',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
